import React from 'react';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';

class LanguageItem extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.onClick(this.props.language);
    }

    render() {
        const {current, language} = this.props;
        return (
            <li className={classNames('list-inline-item', {active: current === language})}>
                <a onClick={this.handleClick}>
                    <FormattedMessage {...messages.languages[language]} />
                </a>
            </li>
        );
    }
}

export default LanguageItem;
